import type { AddressAutocompleteOption } from '@/utils/types/addressAutocompleteOption.interface';
import type { Address } from '@/utils/types/renter.interface';

export const mapBuildingToAddress = (option: AddressAutocompleteOption | null): Address | null => {
  if (!option) return null;

  return {
    monolith_building_id: option.monolith_building_id,
    source: option.source,
    property_id: option.property_id,
    property_alpha_id: option.property_alpha_id,
    address_id: option.address_id,
    line1: option.name,
    city: option.city,
    state: option.state,
    postal_code: option.zip_code,
  };
};
